window.CompareCompetitorsTable = phrase => {
	return {
		val: phrase,
	};
};
